import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ModalFilter.css';
import { Modal } from 'react-bootstrap';

import Listings from './Listings';

import { closeTransactionModal } from '../../../actions/modalActions';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

const ModalFilter = ({ showPayouts, handleResults, mode }) => {

  const transactionModal = useSelector(state => state.modalStatus.transactionModal);
  const dispatch = useDispatch();

  return (
    <Modal show={transactionModal} onHide={() => dispatch(closeTransactionModal())} dialogClassName={'loginModal'}>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage {...messages.filter} /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={s.root}>
          <Listings
            handleResults={handleResults}
            showPayouts={showPayouts}
            mode={mode}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

ModalFilter.propTypes = {
  closeTransactionModal: PropTypes.func.isRequired,
  transactionModal: PropTypes.bool,
  showPayouts: PropTypes.bool.isRequired,
  handleResults: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
};

ModalFilter.defaultProps = {
  transactionModal: false,
};

export default withStyles(s)(ModalFilter);